import { module } from 'modujs';
import Swiper, {Navigation, Pagination, Autoplay, EffectFade} from 'swiper/bundle';




export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {

        this.swiper = new Swiper(this.$( 'swiper' )[0] , { slidesPerView: "auto", navigation: false, loop: true, speed: 500, freeMode: true });
        this.call('updateLazy', false, 'Scroll');
        //this.call( 'add', '-no-prev' , 'Cursor');
        this.maxIndex = this.el.querySelectorAll( '.swiper-slide' ).length - 1;
        if( this.$( 'prev' ).length ){
            this.$( 'prev' )[0].addEventListener( 'click', () => {
                this.call( 'remove', '-no-next' , 'Cursor');
                this.swiper.slidePrev();
                if( this.swiper.activeIndex === 0 ){
                    this.call( 'add', '-no-prev' , 'Cursor');
                }
            } );
        }

        if( this.$( 'next' ).length ){
            this.$( 'next' )[0].addEventListener( 'click', () => {
                this.call( 'remove', '-no-prev' , 'Cursor');
                if( this.swiper.activeIndex < this.maxIndex - 1 ){
                    this.swiper.slideNext();
                }
                if( this.swiper.activeIndex === this.maxIndex - 1 ){
                    this.call( 'add', '-no-next' , 'Cursor');
                }
            } );
        }

    }
    destroy(){}
}
